"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicDialog = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Dialog_1 = __importDefault(require("@mui/material/Dialog"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var DialogTitle_1 = __importDefault(require("@mui/material/DialogTitle"));
var DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
var DialogActions_1 = __importDefault(require("@mui/material/DialogActions"));
var BasicDialog = function (props) {
    var title = props.title, body = props.body, dismissButtonText = props.dismissButtonText, _a = props.open, open = _a === void 0 ? false : _a, sx = props.sx, dialogProps = __rest(props, ["title", "body", "dismissButtonText", "open", "sx"]);
    return (react_1.default.createElement(Dialog_1.default, __assign({ sx: sx }, dialogProps, { open: open }),
        react_1.default.createElement(DialogTitle_1.default, { sx: {
                pt: { md: 4, sm: 2 },
                px: { md: 3, sm: 2 },
                pb: 0,
            } }, title),
        react_1.default.createElement(DialogContent_1.default, { sx: {
                flex: '1 1 auto',
                overflow: 'auto',
                display: 'flex',
                flexDirection: 'column',
                pt: 2,
                px: { md: 3, sm: 2 },
                pb: { md: 2, sm: 3 },
            } },
            react_1.default.createElement(Typography_1.default, null, body)),
        react_1.default.createElement(DialogActions_1.default, { sx: {
                justifyContent: 'flex-end',
                p: { md: 3, sm: 2 },
            } },
            react_1.default.createElement(Button_1.default, { variant: "text", color: "primary", onClick: dialogProps.onClose, sx: { width: 100 } }, dismissButtonText || 'Okay'))));
};
exports.BasicDialog = BasicDialog;
